import { inject, Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserStore } from 'features/user/store/user.store';

@Injectable()
export class UserProfileInterceptor implements HttpInterceptor {
  readonly userStore = inject(UserStore);

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Respect an explicit ProfileKey the caller already set (e.g. the system-admin Profiles page
    // scoping an Integrations request to another profile). HttpHeaders.has is case-insensitive, so
    // this also matches a lowercase `profilekey`. Only fall back to the user's active profile when
    // no override is present — otherwise this would clobber the intended target profile.
    if (req.headers.has('ProfileKey')) {
      return next.handle(req);
    }

    const userProfile = this.userStore.userProfile();

    if (userProfile && userProfile !== '') {
      const request = req.clone({
        headers: req.headers.set('ProfileKey', userProfile),
      });
      return next.handle(request);
    }

    return next.handle(req);
  }
}
